import theme from '../../base';

const checkbox = {
  default: {
    bg: theme.colors.neutrals.gray800,
    border: theme.colors.neutrals.gray200,
    label: theme.colors.neutrals.gray200,
  },
  checked: {
    bg: theme.colors.blues.blue500,
    border: theme.colors.blues.blue500,
    icon: theme.colors.neutrals.white,
  },
  disabled: {
    bg: theme.colors.neutrals.gray800,
    border: theme.colors.neutrals.gray700,
    icon: theme.colors.neutrals.gray700,
  },
  error: {
    bg: theme.colors.reds.red100,
    border: theme.colors.reds.red900,
  },
  focus: {
    border: theme.colors.neutrals.gray800,
    offsetShadow: theme.colors.blues.blue500,
    insetShadow: theme.colors.neutrals.gray800,
  },
  bulk: {
    symbol: theme.colors.neutrals.gray200,
  },
};

export default checkbox;
